import React, { Component } from 'react';
import _ from 'lodash';
import moment from 'moment-timezone';
import { DatePicker } from 'antd';
import { string, bool, shape, object, arrayOf } from 'prop-types';
import { connect } from 'react-redux';
import { notify } from 'react-notify-toast';
import { withRouter } from 'react-router-dom';
import { Form, Formik, FieldArray } from 'formik';
import { Radio, LabeledContainer } from 'src/components/layout';
import { Input, Select, Button, DragContainer } from 'src/components/shared';
import { getPresetsDropdown, getCurrentCollection, deleteCurrentCollection } from 'src/actions/prioritize';
import collectionApi from 'src/api/v2/CollectionApi'
import Footer from 'src/pages/Prioritize/Create/Footer'
import Create from './'
import Prioritize from '../'
import Header, { Subtitle } from '../Header'
import Initiative from './Initiative'
import { GLOBAL_PATH_PREFIX } from 'src/constants';
import { ROUTE_PRIORITIZE_CREATE } from 'src/Routes'
import {
  LABELS,
  ITEM_CUSTOM_ATTR_OPTIONS,
  DEFAULT_CUSTOM_ATTR_VALUE,
  DEFAULT_SUB_COLLECTIONS,
  DEFAULT_SUB_COLLECTION,
  EDIT_PAGES_REGEX
} from 'src/util/PrioritizeUtil'


const constantPayloadFields = {
  timezone: moment.tz.guess(),
  collection_type: 'prioritize',
}

class ManageCollection extends Component {

  constructor(props) {
    super(props)

    this.state = {
      selectedPreset: props.presets ? props.presets.find(p => p.public) : {},
      title: props.collection.title || '',
      subCollections: props.collection.children,
      endDatetime: props.collection.end_on
        ? moment(props.collection.end_on)
        : moment(moment()).add(3, 'days'),
      custom_attr_1: DEFAULT_CUSTOM_ATTR_VALUE,
      titleWarning: false,
      isCreateView: props.location.pathname.includes(ROUTE_PRIORITIZE_CREATE),
      disabledButtons: []
    }
  }

  isStepOneComplete = () => {
    const { title, subCollections } = this.state
    return !_.isEmpty(title) && subCollections.filter((obj) => obj.title).length > 0;
  }

  onStateChange = (field, value) => {
    if (this.isStepOneComplete()) {
      this.setState({ titleWarning: false })
    }
    this.setState({
      [field]: value
    })
  }

  disabledDate = (current) => {
    return current < moment().day();
  }

  updateCollectionChildren = async (parentId, children = [], newItemsIds = []) => {
    if (!parentId || !children.length) return
    const existingChildren = []
    const newChildren = []

    children.forEach((child, idx) => {
      if (child.id && !newItemsIds.includes(child.id) ) {
        existingChildren.push({ ...child, sort_order: idx })
      } else {
        newChildren.push({ ...child, sort_order: idx, collection_type: 'prioritize-item' })
      }
    });

    if (existingChildren.length) {
      const promises = existingChildren.map(child => collectionApi.update(child))
      await Promise.all(promises)
    }

    if (newChildren.length) {
      await collectionApi.createChildren(parentId, newChildren)
    }
  }


  saveUpdate = async (valuesFromForm) => {
    const { title, end_on, custom_attr_1, collection_children, newItemsIds } = valuesFromForm
    const { id } = this.props.collection
    const payload = {
      id,
      title,
      custom_attr_1,
      end_on: moment.tz(end_on, moment.tz.guess()).local().format(),
      ...constantPayloadFields
    }
    await Promise.all(collectionApi.update(payload), this.updateCollectionChildren(id, collection_children, newItemsIds))
    const updatedDetails = await collectionApi.get({ id })
    this.props.getCurrentCollection(updatedDetails);
  };

  saveCreate = async (valuesFromForm) => {
    const { title, end_on, custom_attr_1, selected_preset, collection_children } = valuesFromForm
    const payload = {
      title,
      custom_attr_1,
      end_on: moment.tz(end_on, moment.tz.guess()).local().format(),
      collection_sub_type: selected_preset.collection_sub_type,
      ...constantPayloadFields
    }

    try {
      const children = collection_children
        .filter(item => item.title)
        .map(({ title, description, custom_attr_1 }) => ({ title, description, custom_attr_1, collection_type: 'prioritize-item' }));

      const rootCollection = await collectionApi.create(payload)
      // this.setState({ id: rootCollection.id });

      // Create children
      const newChildren = await collectionApi.createChildren(rootCollection.id, children)
      rootCollection.children = newChildren;

      // Create questions using selected category
      const selectedPresetCollection = await collectionApi.get({ id: selected_preset.id })
      await collectionApi.createQuestions(rootCollection.id, selectedPresetCollection.questions)

      // Reload details with all newly created children and questions
      const collectionDetails = await collectionApi.get({ id: rootCollection.id })
      this.props.getCurrentCollection(collectionDetails);
      return rootCollection.id;

    } catch (error) {
      console.error(error);
    }
  };

  onNext = (values, methods) => {
    console.log(values);
    const { location, history } = this.props;

    if (this.props.collection?.id) {
      this.saveUpdate(values);
    } else {
      this.saveCreate(values).then(newCollectionId => {
        history.push(`${GLOBAL_PATH_PREFIX}/p/${newCollectionId}/edit/factors`)
      }).catch(console.error);
    }

    if (location.pathname.match(EDIT_PAGES_REGEX)) {
      const lp = location.pathname
      const currentLocation = lp[lp.length - 1] === '/' ? lp.slice(0, -1) : lp
      history.push(`${currentLocation}/factors`)
    }

  }


  onButtonClick = (buttonType) => () => {
    const { subCollections } = this.state

    switch (buttonType) {
      case 'next':
        // this.onNext()
        break;
      case 'add':
        this.onStateChange('subCollections', [...subCollections, { title: '', custom_attr_1: '' }])
        break;

      default:
        break;
    }
  }

  componentDidMount = () => {
    const { isCreateView } = this.state
    const { collection, deleteCurrentCollection } = this.props
    if (isCreateView && collection)
      deleteCurrentCollection()
  }

  onPaste = (setFieldValue, collection_children) => (idx) => (e) => {
    const arrayToObj = ([title, custom_attr_1]) => ({ title, custom_attr_1: custom_attr_1 || '' })
    const strToItem = (str) => arrayToObj(str.split(/\t/g))

    const rawText = e.clipboardData.getData('Text') || ''
    const tabSeparatedLines = rawText.split(/\n/g)

    if (tabSeparatedLines.length > 1) {
      e.preventDefault()

      const cleanPastedItems = tabSeparatedLines.map(strToItem).filter((item) => item.title)
      const newColChildren = [...collection_children]

      newColChildren.splice(idx, 0, ...cleanPastedItems)
      setFieldValue('collection_children', newColChildren)
      // this.props.onStateChange('subCollections', newSubCollections)
    }
  }

  onItemTypeChange = (setFieldValue, presets) => ({ target }) => {
    const newPreset = presets.find(preset => preset.collection_sub_type === target.value)
    setFieldValue('selected_preset', newPreset)
  }

  onItemAdd = (setFieldValue, collection_children, newItemsIds = []) => () => {
    const id = collection_children.length + 1
    setFieldValue('newItemsIds', [...newItemsIds, id])
    setFieldValue('collection_children', [...collection_children, {...DEFAULT_SUB_COLLECTION, id }])
  }

  // validate = (values) => {
  //   const errors = {};
  //   if (!values.title) {
  //     errors.title = 'Title field is required';
  //   }
  //   const children = values.collection_children
  //   if (!children || !children.filter(child => child.title).length) {
  //     errors.collection_children = 'Must be at least one item to evaluate with name';
  //   }
  //   console.log(errors);
  //   const keys = Object.keys(errors)
  //   if (keys.length)
  //     notify.show(errors[keys[0]], 'warning', 3000);
  //   return errors;
  // };

  // revised for bigger font on mobile devices
  validate = (values) => {
    const errors = {};
  
    // Validation for title
    if (!values.title) {
      errors.title = 'Title field is required';
    }
  
    // Validation for collection_children
    const children = values.collection_children;
    if (!children || !children.filter(child => child.title).length) {
      errors.collection_children = 'Must be at least one item to evaluate with name';
    }
  
    console.log(errors);
  
    // Display the first error using a toast
    const keys = Object.keys(errors);
    if (keys.length) {
      const isMobile = window.innerWidth <= 768; // Detect if on a mobile screen
      const fontSize = isMobile ? '24px' : '16px'; // Adjust font size for toast message
  
      // Inline style adjustment
      const toastStyle = {
        fontSize,
      };
  
      notify.show(
        <div style={toastStyle}>{errors[keys[0]]}</div>, // Styled error message
        'warning',
        3000
      );
    }
  
    return errors;
  };
  


  render() {
    const {
      isCreateView,
      disabledButtons
    } = this.state
    const { collection, presets } = this.props
    const { id, title, end_on, children = [], custom_attr_1 = DEFAULT_CUSTOM_ATTR_VALUE } = collection

    const step = 1
    console.log('render');

    const selected_preset = presets ? presets.find(p => p.public) : {}

    if (!collection.title && !isCreateView) return (
      <Create onNavClick={this.onButtonClick} step={step} disabledButtons={disabledButtons} >
      </Create>
    )

    if (!presets.length && isCreateView) return (
      <Create onNavClick={this.onButtonClick} step={step} disabledButtons={disabledButtons} >
      </Create>
    )

    return (
      <Prioritize
        title={title}
        redText={`Step ${step} of 2`}
        step={step}
        headerNav={true}
        disabledButtons={disabledButtons}
      >
        <div className='create__progress' style={{ width: `${step * 50}%` }}></div>

        <Formik
          initialValues={{
            id,
            title,
            end_on: end_on || moment().add(3, 'days'),
            custom_attr_1,
            collection_children: children,
            presets,
            selected_preset,
            newItemsIds:[]
          }}
          onSubmit={this.onNext}
          validate={this.validate}
          validateOnChange={false}
          validateOnBlur={false}
          enableReinitialize
        >
          {({
            values: {
              id,
              title,
              end_on,
              custom_attr_1,
              collection_children,
              presets,
              selected_preset,
              newItemsIds
            },
            handleChange,
            handleBlur,
            handleSubmit,
            isSubmitting,
            setFieldValue,
          }) => {

            const onItemDrag = (payload) => {
              setFieldValue('collection_children', payload)
            }

            const onItemDrop = async () => {
              this.updateCollectionChildren(id, collection_children.map((c, i) => ({ ...c, sort_order: i })), newItemsIds)
              setFieldValue('newItemsIds', [])
            }

            return (
              <Form>
                <Header hasNav >
                  <div className='prioritize__header-title'>
                    <Subtitle text={`Step ${step} of 2`} />
                    <h1>{LABELS.create_steps_title[step - 1]}</h1>
                  </div>

                  <div className="prioritize__header-nav">
                    <Button lg primary submit
                      disabled={isSubmitting}
                      onClick={handleSubmit}>
                      Next
                    </Button>
                  </div>
                </Header>

                <div className="content_container">
                  {isCreateView && (
                    <LabeledContainer className="create-step1__types" title={LABELS.create_category} >
                      <div>
                        {presets.filter(preset => preset.public).map((preset, idx) =>
                          <Radio
                            key={idx}
                            name="selected_preset"
                            label={preset.title}
                            onChange={this.onItemTypeChange(setFieldValue, presets)}
                            value={preset.collection_sub_type}
                            isChecked={selected_preset && selected_preset.collection_sub_type === preset.collection_sub_type}
                          />
                        )}
                      </div>
                    </LabeledContainer>
                  )}

                  <div className="create-step1__grid">

                    <LabeledContainer
                      titleWarning={false}
                      className="create-step1__input_title"
                      title={LABELS.create_title}
                      afterTitle={false ? <span>*</span> : null}
                    >
                      <Input
                        name="title"
                        className={false ? 'create-step1__input_title--red' : ''}
                        placeholder={'Example: 2021 Initiatives, Evaluate SSO vendors, Project XYZ'}
                        onChange={handleChange}
                        value={title}
                      />
                    </LabeledContainer>

                    <LabeledContainer title="End Time" >
                      <DatePicker
                        size='large'
                        name="end_on"
                        format="ddd MMM D, h:mm a"
                        disabledDate={this.disabledDate}
                        value={moment(end_on)}
                        showTime={{
                          use12Hours: true, format: "h:mm a", defaultValue: moment(end_on), minuteStep: 15
                        }}
                        onChange={(newDate) => setFieldValue('end_on', newDate)}
                      />
                    </LabeledContainer>

                  </div>

                  <div className="list-section">
                    <div className="list-header">
                      <div className="create-step1__grid estimated-cost">
                        <Select
                          id="custom-attr-1"
                          name="custom_attr_1"
                          value={custom_attr_1}
                          itemList={ITEM_CUSTOM_ATTR_OPTIONS}
                          onSelected={(item) => setFieldValue('custom_attr_1', item.value)}
                          border={false}
                        />
                      </div>
                      <div className="list-title">
                        <label>{LABELS.create_subCollections}</label>
                      </div>
                    </div>
                    <FieldArray
                      name="collection_children"
                      render={arrayHelpers => {
                        const onInitiativeChange = (collection_child) => (idx, field, val) => {
                          arrayHelpers.replace(idx, { ...collection_child, [field]: val })
                        }
                        return (
                          <DragContainer
                            itemList={collection_children}
                            setItemList={onItemDrag}
                            dropItem={onItemDrop}
                            render={(collection_child, idx) => (
                              <Initiative
                                key={idx}
                                idx={idx}
                                custom_attr_1={custom_attr_1}
                                collection={collection_child}
                                setFieldValue={onInitiativeChange(collection_child)}
                                arrayHelpers={arrayHelpers}
                                onItemAdd={this.onItemAdd(setFieldValue, collection_children, newItemsIds)}
                                onPaste={this.onPaste(setFieldValue, collection_children)}
                                isLast={idx === collection_children.length - 1}
                              />
                            )}
                          />
                        )
                      }}
                    />

                  </div>
                </div>

                <Footer>
                  <div>
                    <Button type="button" lg flat cancel className="create__add"
                      disabled={isSubmitting}
                      onClick={this.onItemAdd(setFieldValue, collection_children, newItemsIds)}>Add Item</Button>
                  </div>

                  <div>
                    <Button type="submit" lg primary submit
                      onClick={handleSubmit} disabled={isSubmitting}>Next</Button>
                  </div>
                </Footer>
              </Form>
            )
          }}
        </Formik>
      </Prioritize>
    )
  }
}

ManageCollection.propTypes = {
  selectedPreset: string,
  titleWarning: bool,
  endDatetime: object,
  presets: arrayOf(shape({
    title: string,
    collection_sub_type: string
  })),
  collection: shape({
    children: arrayOf(shape({
      title: string,
      custom_attr_1: string
    }))
  }),
};

ManageCollection.defaultProps = {
  selectedPreset: '',
  titleWarning: false,
  endDatetime: null,
  presets: [],
  collection: DEFAULT_SUB_COLLECTIONS,
};

const mapStateToProps = ({ prioritize }) => {
  return {
    presets: prioritize && prioritize.presets,
    collection: prioritize && prioritize.collection
  };
};

export default withRouter(connect(mapStateToProps, {
  getCurrentCollection,
  deleteCurrentCollection,
  getPresetsDropdown
})(ManageCollection));
